import FactureAvoirSelectController from './facture.avoir.select.controller';

export default {
    bindings: {
        modalInstance: '=',
        idFactures: '=',
        date: '=',
        avoirData: '='
    },
    template: require('./facture.avoir.select.html'),
    controller: FactureAvoirSelectController
};